module.exports = __webpack_public_path__ + "img/0f1f0d1.jpg";